import React, { useState, useEffect, useRef } from 'react';
import {Button, Container, Hidden, IconButton, Typography} from '@mui/material';
import {AddBox, OpenInNewRounded, ChevronLeftRounded, ChevronRightRounded} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import MaterialTable from 'material-table';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import {getMediaURL, scrollTop} from "../../../../config/values";
import {TableCount, TablePage} from "../../../../config/Permissions";
import {getDataTableLocalization} from "../../../../config/Translate";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {tableIcons} from "../../../../config/design/TableIcons";
import {defaultVariables} from "../../../../config";
import {useIsSmall} from "../../../../config/hooks/useWindowDimensions";
import {useTranslation} from "react-i18next";
import {Wallet} from "lucide-react";

const Shops = ({ classes }) => {
    const isSmall = useIsSmall();
    const { t } = useTranslation();

    const [columns] = useState([
        {
            field: 'logo',
            editable: 'never',
            filtering: false,
            sorting: false,
            hidden: isSmall,
            title: t('logo'),
            render: rowData => !!rowData.logo && <img alt="avatar" src={rowData.logo} className={classes.avatar} />
        },
        {
            title: t('shopName'),
            field: 'name',
            filterPlaceholder: t('search'),
            sorting: false,
        },
        {
            title: t('industry'),
            field: 'industry',
            filterPlaceholder: t('search'),
            sorting: false,
        },
        {
            title: t('status'),
            editable: 'never',
            field: 'status',
            sorting: false,
            filterPlaceholder: t('choose'),
            lookup: {
                "active": <Typography className="table-badge active">{t('active')}</Typography>,
                "pending": <Typography className="table-badge pending">{t('pending')}</Typography>,
                "inactive": <Typography className="table-badge inactive">{t('inactive')}</Typography>
            }
        },
        {
            title: t('activity'),
            editable: 'never',
            field: 'activity',
            sorting: false,
            render: rowData => (
                <>
                    <Button
                        variant="outlined"
                        color="secondary"
                        component={Link}
                        to={`/panel/manage/shops/edit/${rowData.id}`}
                        endIcon={<ChevronRightRounded />}
                        size="small"
                        style={{ margin: 5 }}
                    >
                        {t('details')}
                    </Button>
                    {
                        !!rowData.wallet_id &&
                        <IconButton component={Link} size="small" to={`/panel/manage/wallets/transactions/${rowData.wallet_id}`}><Wallet /></IconButton>

                    }
                </>

            )
        }
    ]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const tableRef = useRef(null);
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () => {
        tableRef.current && tableRef.current.onQueryChange();
    };

    const onDelete = async (id, hasNotif = true) => {
        try {
            const loginToken = localStorage.getItem('ACT');
            let data = new FormData();
            data.append('id', id);
            await axios.post(`${defaultVariables.url}/shops/remove`, data, {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            });
            if (hasNotif) enqueueSnackbar(t('deleteData'), { variant: 'success' });
            loadData();
        } catch (error) {
            console.log(error.response)
            enqueueSnackbar(t('deleteDataFailed'), { variant: 'error' });
        }
    };

    useEffect(() => {
        loadData();
        scrollTop();
    }, []);

    return (
        <>
            {
                loading ? "Loading" :
                    <div className="main-table">
                        <MaterialTable
                            tableRef={tableRef}

                            icons={tableIcons}
                            title={
                                <>
                                    <Link to='/panel/manage/shops/add'>
                                        <Hidden mdDown>
                                            <Button variant="contained" color="secondary" startIcon={<AddBox />}>
                                                {t('makeShop')}
                                            </Button>
                                        </Hidden>
                                        <Hidden mdUp>
                                            <IconButton color="primary">
                                                <AddBox />
                                            </IconButton>
                                        </Hidden>
                                    </Link>
                                </>
                            }
                            localization={getDataTableLocalization()}
                            columns={columns}
                            data={query =>
                                new Promise((resolve, reject) => {
                                    axios.get(`${defaultVariables.url}/shops/quickView?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`, {
                                        headers: {
                                            Accept: 'application/json',
                                            Authorization: `Bearer ${localStorage.getItem('ACT')}`
                                        }
                                    }).then(response => {
                                        const data = response.data.data.map(row => ({
                                            id: row.id,
                                            name: row.name,
                                            industry: t(row.industry?.name),
                                            logo:getMediaURL(row.logo,'small'),
                                            created_at: row.created_at,
                                            status: row.status,
                                            wallet_id: row.owner?.wallet?.id,
                                        }));
                                        resolve({
                                            data: data,
                                            page: response.data.current_page - 1,
                                            totalCount: response.data.total
                                        });
                                    }).catch(error => console.log(error.response));
                                })
                            }
                            options={{
                                pageSize: TablePage,
                                pageSizeOptions: TableCount,
                                defaultExpanded: false,
                                draggable: false,
                            }}
                            editable={{
                                onRowDelete: oldData =>
                                    new Promise(resolve => {
                                        setTimeout(() => {
                                            resolve();
                                            onDelete(oldData.id);
                                            setData(prevData => prevData.filter(item => item.id !== oldData.id));
                                        }, 600);
                                    })
                            }}
                        />
                    </div>
            }
        </>
    );
};
export default withStyles(Styles)(Shops);
